import axios from "axios";



const httpClientReq =axios.create({
    baseURL:process.env.REACT_APP_BASE_URL
})

httpClientReq.interceptors.request.use(
    config=>{
        return config;
    },
    error =>{
        return Promise.reject(error);
    }
);
httpClientReq.interceptors.response.use(
    response=>{
        return response;
    },
    error =>{
        return Promise.reject(error);
    }
);
 
export default httpClientReq;